<template>
  <div class="header sticky">
    <div class="container">
      <img @click="$router.push('/')" src="@/assets/logo-fdci.png" alt="" class="logo">
      <!-- <div style="float:right">
        <img src="@/assets/icons/docente.svg" alt="">
        Juan Alderete
      </div> -->

      <el-popover placement="top-start" title="" width="200" trigger="hover" v-if="!$isMobile()"
        content="Acceda a su Espacio de Formación Personal">

        <avatar slot="reference" fullname="ESPACIO F PERSONAL" @click.native="acceder" class="avatarLog" :size="55">
        </avatar>
      </el-popover>


      <img src="@/assets/superior.png" v-if="!$isMobile()" @click="open"
        style="float:right; margin-right:30px; cursor:pointer" alt="">

    </div>
    <nav class="main-menu" v-if="!$isMobile() ">
      <div class="container">
        <ul>
          <li><router-link to="/" class="el-icon-s-home"></router-link></li>
          <li v-if="!$isMobile() "><a href="https://des-tuc.infd.edu.ar/sitio/" target="_blank">Dirección de Nivel Superior</a></li>
          <li v-if="!$isMobile() "><a href="https://aulas.educaciontuc.gov.ar/" target="_blank">Aulas Virtuales</a></li>
          <li v-if="!$isMobile()"><router-link to="/docentes">Espacio de formación personal
            </router-link></li>
          <li><router-link to="/deberes-y-derechos-fdci">Normativa</router-link></li>
          <!-- <li><router-link to="/contacto">Contacto</router-link></li> -->
        </ul>
      </div>
    </nav>

    <!--MENU PARA MOVIL-->
    <div class="menu-movil" v-if="$isMobile()">
      <el-button type="primary" @click="mostrarMenu = !mostrarMenu" icon="el-icon-menu">
        Menú
      </el-button>

      <transition name="fade">
        <div class="menu-desplegable" v-if="mostrarMenu">
          <ul>
            <li><router-link to="/"> Inicio</router-link></li>
            <li><a href="https://des-tuc.infd.edu.ar/sitio/" target="_blank">Dirección de Nivel Superior</a></li>
            <li><a href="https://aulas.educaciontuc.gov.ar/" target="_blank"> Aulas Virtuales</a></li>
            <li><router-link to="/docentes">Espacio de Formación Personal</router-link></li>
            <li><router-link to="/deberes-y-derechos-fdci"> Normativa</router-link></li>
          </ul>
        </div>
      </transition>
    </div>
    <!-- FIN DEL MENU MOVIL-->  
    
    <div v-if="mostrarNombreHeader && $route.name === 'detalleCapa'">
      <div class="container">
        <h1 class="nombre">{{ mostrarNombreHeader }}</h1>
      </div>

      <MenuMovil :offset="'header'" v-if="$isMobile()" />


    </div>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus"
import Avatar from 'vue-avatar-component'
import MenuMovil from '@/components/capacitacion/MenuMovil.vue'

  export default { 
  components: { Avatar, MenuMovil },
  data() {
    return {
      userData: window.sessionStorage.getItem('docente'),
      userDataCuil: window.localStorage.getItem('userDataCuil'),
      userDataPass: window.localStorage.getItem('userDataPass'),
      mostrarNombreHeader:false,
      menuMobil:'detalles',

      mostrarMenu: false,

    }
  },
  created()
  {
    EventBus.$on('mostrarNombreHeader',(n) => {
      this.mostrarNombreHeader = n
    })
  
  },
    methods: {
      
      acceder()
      {
        if (this.$route.name !== 'docentes')
        {
          if (this.userData) {
            if (this.userDataCuil && this.userDataPass) {
              const loginData = {
                cuil: this.userDataCuil,
                pass: this.userDataPass
              }
              EventBus.$emit('loguear', loginData)
              this.$router.push({ name: 'docentes' })
            }
            else {
              this.$router.push({ name: 'docentes' })
            }
          }
          else {
            this.$router.push({ name: 'docentes' })
          }
        }
      
      },
      open() {
        window.open('https://des-tuc.infd.edu.ar/sitio/', '_blank')
      }
    },
  }
</script>

<style lang="scss" scoped>

.nombre {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0px;
  padding:10px 20px;
  background: #f1f1f16b;
    border-top: 1px solid #0b395d3d;
    border-bottom: 1px solid #0b395d26;
}

.nombre small {
  display: block;
}
.avatarLog {
 float:right; cursor:pointer;margin-top:0px
}
.header{
  padding: 0px;
  padding-top: 10px;
}
.header img{
 height:60px;

}
.main-menu {
  background:#0b395d;
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    padding: 6px;
    

    li {
      color:white;
      display: inline;
      margin-right: 20px;
     

      a {
        text-decoration: none;
        color: #FFF; // Example link color
        font-size: 14px;
        
      }
    }
  }
}

// Media query for smaller screens
@media (max-width: 768px) {
  .header img {
      height: 50px;
      padding: 10px;
  
    }
  .main-menu {
    // display: none; // Hide the menu on small screens
  }
     .sticky {
       position: -webkit-sticky;
       /* Safari */
       position: sticky;
       top: 0;
       z-index: 1000;
       /* Para asegurarte de que quede encima de otros elementos */
       background-color: white;
       /* Opcional: puedes cambiar el fondo */
       box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
       /* Agrega una sombra para destacar el elemento */
     }
.avatarLog {
  float: right;
  cursor: pointer;
  margin: 5px 10px
}
  .container {
    flex-direction: column; // Stack items vertically on small screens
  }
}

.menu-movil {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 2000;

  .el-button {
    background-color: #006eb9;
    color: white;
    font-weight: bold;
    border-radius: 8px;
  }

  .menu-desplegable {
    position: absolute; /* <-- esto es lo clave */
    top: 50px;           /* distancia desde el botón */
    right: 0;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 10px;
    width: 250px;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin: 10px 0;

        a {
          text-decoration: none;
          color: #0b395d;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 6px;
        }
      }
    }
  }
}
</style>